import * as React from 'react';
import { getClassName } from '../../util/string-util';
import { FieldContextConsumer } from './Field';
import './Label.scss';

export const Label: React.SFC<
  React.HTMLAttributes<HTMLLabelElement> & React.LabelHTMLAttributes<HTMLLabelElement>
> = ({ className, htmlFor, ...props }) => (
  <FieldContextConsumer>
    {contextVal => (
      <label
        htmlFor={htmlFor || contextVal.fieldId}
        className={getClassName(
          'label',
          className,
          contextVal.isFilled && 'is-filled',
          contextVal.isFocused && 'is-focused'
        )}
        {...props}
      />
    )}
  </FieldContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/Control/Label.tsx